import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import * as stageTypes from '../../types';
import { StageSandbox } from '../../services/stage.sandbox';
import { Observable } from 'rxjs/Rx';
import * as commonTypes from '../../../shared/types';
import * as stageResponse from '../../types/stage-response';
import { Subscription } from "rxjs/Subscription";
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'tr-doc-confirmation-container',
  templateUrl: './doc-confirmation-container.component.html',
  //styleUrls: ['./doc-confirmation-container.component.scss']
})
export class DocConfirmationContainerComponent implements OnInit, OnDestroy {

  @Input() entity: stageTypes.IPage;

  private subscriptions: Array<Subscription> = [];
  private documents: stageResponse.IHtmlElement[];
  private allAttachmentsConfirmed: boolean = false;
  @ViewChild('updateStageConfirmation') updateStageConfirmation: ElementRef;
  private currentAction: string = '';

  constructor(private sb: StageSandbox, private modalService: NgbModal) {
    this.subscriptions.push(
      this.sb.getAllAttachmentsConfirmationStatus$().subscribe( (allConfirmed: boolean) => this.allAttachmentsConfirmed = allConfirmed),
    );
  }

  ngOnDestroy() {
    // Called once, before the instance is destroyed.
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  viewedDocumentStatus$(questionId: number): Observable<boolean> {
    return this.sb.getFileReadingStatus$(questionId);
  }

  confirmedDocumentStatus$(questionId: number): Observable<boolean> {
    return this.sb.getFileConfirmationStatus$(questionId);
  }

  isDownloading$(questionId: number): Observable<boolean> {
    return this.sb.getFileDownloadingStatus$(questionId, this.currentAction);
  }

  getFileContent$(questionId: number): Observable<any> {
    return this.sb.getFileContent$(questionId);
  }

  getToken$(): Observable<string> {
    return this.sb.getToken$();
  }

  currentAction$(): Observable<string> {
    return Observable.of(this.currentAction);
  }

  onDocumentAction(actionName: string, question: stageResponse.IHtmlElement) {
    this.currentAction = actionName.toLowerCase();
    if (this.currentAction === 'update') {
      this.modalService.open(this.updateStageConfirmation).result.then((result) => {
        if (result === 'YES') {
          this.subscriptions.push(
            this.sb.onDocumentAction(actionName, question.id)
          );
        }
      }, (reason) => {
        // do nothing
      });
    } else {
      this.subscriptions.push(
        this.sb.onDocumentAction(actionName, question.id)
      );
    }
  }

  // onButtonClicked(action: stageTypes.IAction, id: number): void {
  //   event.stopPropagation();
  //   switch (action.name.toLowerCase()) {
  //     case 'view':
  //       window.open(action.href, 'docview');
  //       this.setComplete(id, 1);
  //       break;
  //     case 'update':
  //       window.location.href = action.href;
  //       this.setComplete(id, 0);
  //       break;
  //     case 'accept':
  //     case 'comfirm':
  //     case 'confirm':
  //       var ret: string;
  //       this.sb.confirmDocument$(action.name, action.href)
  //         .subscribe(result => {
  //           if (result.status === -1) {
  //             alert('There was an error, please try again: ' + result.message);
  //           } else {
  //             ret = result.name;
  //             this.setComplete(id, 2);
  //             alert('Thank you.');
  //           }
  //         });
  //       break;
  //   }
  // }

  onContinue() {
    //this.allAttachmentsConfirmed$.take(1).subscribe (allConfirmed => {
      if (this.allAttachmentsConfirmed) {
        this.subscriptions.push(
          this.sb.confirmAllDocuments$()
            .subscribe((response: commonTypes.IResponse) => this.sb.resetCurrentStageId())
        );
      }
    //});
  }

  ngOnInit() {
    this.documents = this.entity.htmlelements;
  }
}



// WEBPACK FOOTER //
// ./src/app/stage/containers/doc-confirmation-container/doc-confirmation-container.component.ts